// extracted by mini-css-extract-plugin
export var active = "_4s-7";
export var container = "_4s-0";
export var evenWidth = "_4s-4";
export var large = "_4s-5";
export var outlet = "_4s-8";
export var slide = "_4s-2";
export var small = "_4s-6";
export var tab = "_4s-3";
export var tabs = "_4s-1";